var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissedcall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_3485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.364 3.354L12 9L5.63599 3.354",
    stroke: "#FF5353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.434 21H20C21.105 21 22 20.105 22 19V17.986C22 16.957 21.472 16 20.598 15.403C18.441 13.932 15.401 13 12 13C8.599 13 5.559 13.932 3.402 15.404C2.528 16.001 2 16.958 2 17.986V19C2 20.105 2.895 21 4 21H5.566C6.394 21 7.066 20.328 7.066 19.5V18.137C7.066 17.83 7.247 17.546 7.533 17.435C8.859 16.921 10.379 16.625 12 16.625C13.621 16.625 15.141 16.921 16.467 17.435C16.753 17.546 16.934 17.83 16.934 18.137V19.5C16.934 20.328 17.606 21 18.434 21V21Z",
    stroke: "#FF5353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99999 3.354H5.63599V6.718",
    stroke: "#FF5353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_3485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedcall);
export default __webpack_public_path__ + "static/media/missedcall.bcaa00a85499acddfd187383ae9765a9.svg";
export { ForwardRef as ReactComponent };